export default __webpack_public_path__ + "static/media/nft-logo.c7d09401.jpeg";